<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-text">
                    <h2>{{ $t("standardOverview") }}</h2>
                    <p>{{ $t("standardOverviewText") }}</p>
                </div>
                <div class="description-img">
                    <img src="https://resources.fia.ba/file/E6967571-830A-EE11-8B87-00155D1E1252.jpg">
                </div>
            </div>
            <div class="main-part">
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("standardOverviewDescriptionTitle") }}</h3>
                    </div>
                    <p v-html="$t('standardOverviewDescription')"></p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("standardOverviewTypes") }}</h3>
                    </div>
                    <a href="https://www.fia.ba/PublicUpload/Standardni%20pregled%20o%20ocjeni%20finansijskog%20poslovanja%20privrede.pdf" target="_blank">{{ $t("StandardOverviewOfTheAssessmentOfFinancialOperationsOfTheEconomy") }}</a>
                    <a href="https://www.fia.ba/PublicUpload/Standardni%20pregled%20o%20ocjeni%20finansijskog%20poslovanja%20privredne%20%20grane.pdf" target="_blank">{{ $t("StandardOverviewOfTheAssessmentOfTheFinancialPerformanceOfTheIndustry") }}</a>
                    <a href="https://www.fia.ba/PublicUpload/Standardni%20pregled%20o%20ocjeni%20finansijskog%20poslovanja%20djelatnosti.pdf" target="_blank">{{ $t("StandardOverviewOfTheAssessmentOfTheFinancialPerformanceOfTheActivity") }}</a>
                    <a href="https://www.fia.ba/PublicUpload/PregledPoslovanja.pdf" target="_blank">{{ $t("StandardOverviewOfTheAssessmentOfTheFinancialPerformanceOfALegalEntity") }}</a>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("specialSelectionOfDataTitle") }}</h3>
                    </div>
                    <p>{{$t("specialSelectionOfDataDescription")}}</p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t('orderTitle') }}</h3>
                    </div>
                    <p>{{ $t('orderProductDescription') }}</p>
                    <a href="https://proizvodi.fia.ba/account/kreiraj" target="_blank">
                        <div class="big-card-btn">{{$t('requestForm')}}</div>
                    </a>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{$t('priceList')}}</h3>
                    </div>
                    <p>{{ $t('priceListButtonDescription') }}</p>
                    <router-link :to="{ name: $t('priceListRouteName')}" class="big-card-btn">{{$t('priceList')}}</router-link>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {}
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getContentByUrl"]),
    },
}
</script>

<style scoped>
</style>
